import reportWebVitals from './reportWebVitals';
import '@ant-design/v5-patch-for-react-19';
import {
    RootApp
} from './_apps/rootApp';
import './index.css';
import { ReactAppRenderer } from './utils/reactApp';
import './appParts.tsx';

ReactAppRenderer(RootApp, 'root');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
